import { useMutation } from '@tanstack/react-query';
import { useNotification } from '../useNotification';
import { useFetchApi } from '../useFetchApi';
import { AddWebhookInput, Webhook } from '../../shared/types';
import { queryClient } from '../../testUtils';

export const useCreateWebhook = () => {
  const fetch = useFetchApi();
  const { showErrorWithResponse } = useNotification();

  return useMutation({
    mutationFn: (webhook: AddWebhookInput) =>
      fetch('webhooks', {
        method: 'POST',
        body: JSON.stringify(webhook),
      }) as Promise<Webhook>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['webhooks'] });
    },
    onError: showErrorWithResponse,
  });
};
